module.exports = __webpack_public_path__ + "static/media/general5-1.c895d5a1.jpg";